<template>
    <div>
        <span v-for="error in errors" class="text-danger d-block">{{ error }}</span>
        
    </div>
</template>

<script>
export default {
    name:'FormErrorsManager',
    props:['errors']
}
</script>